module.exports = __webpack_public_path__ + "static/media/minus.463cde10.svg";